import { Typography, Stack, Box, Tooltip, capitalize } from '@mui/material';
import type { LogRecord } from '@repo/api-gw-sdk';

import { Panels } from '@/components/panels/panels';
import { useWorkspace } from '@/contexts/useWorkspace';
import { PanelSize } from '@/contexts/workspaceContext';
import { dayjs, DATE_TIME_FORMAT } from '@/utils/dayjs';

export const severities: Record<string, string> = {
  UNKNOWN: 'var(--mui-palette-text-disabled)',
  DEBUG: 'var(--mui-palette-text-disabled)',
  INFO: 'var(--mui-palette-info-main)',
  WARN: 'var(--mui-palette-warning-main)',
  ERROR: 'var(--mui-palette-custom-RED-04)',
  FATAL: 'var(--mui-palette-custom-RED-01)',
};

export const SeverityCircle = ({ severity }: { severity?: string }) =>
  severity &&
  severities[severity] && (
    <Tooltip title={capitalize(severity.toLowerCase())}>
      <Box
        height='8px'
        width='8px'
        minWidth='8px'
        minHeight='8px'
        borderRadius='50%'
        sx={{ background: severities[severity] }}
      />
    </Tooltip>
  );

export const LogTimeCell = ({ entry }: { entry: LogRecord }) => {
  const { rightPanel } = useWorkspace();

  return (
    <Stack direction='row' alignItems='center' gap='12px'>
      <SeverityCircle severity={entry.level} />
      <Typography
        className='underline hover:cursor-pointer hover:text-[var(--mui-palette-text-secondary)]'
        onClick={() => {
          rightPanel.setComponent({
            panel: Panels.LogSpaceRecordCard,
            props: {
              entry,
              onClose: () => rightPanel.setIsOpen(false),
            },
          });

          const shouldOpen =
            !rightPanel.isOpen ||
            (!!rightPanel.Component?.props &&
              'entry' in rightPanel.Component.props &&
              'rowId' in rightPanel.Component.props.entry &&
              rightPanel.Component.props.entry.rowId !== entry.rowId);

          rightPanel.setIsOpen(shouldOpen, PanelSize.Large);
        }}
      >
        {dayjs.utc(entry?.timestamp).format(DATE_TIME_FORMAT)}
      </Typography>
    </Stack>
  );
};
